// src/components/job-engine/useJobEngineEvent.ts
import { useCallback, useEffect } from "react";
import { signalRService } from "./signalRService";
import type { JobEngineEventName } from "@/api/jobEngine";

export default function useJobEngineEvent<T>(
  eventName: JobEngineEventName,
  handler: (data: T) => void,
  enabled = true
): void {
  const cb = useCallback(
    (data: unknown) => handler(data as T),
    [handler]
  );

  useEffect(() => {
    if (!enabled) return;
    signalRService.on(eventName, cb);
    return () => signalRService.off(eventName, cb);
  }, [eventName, cb, enabled]);
}
